/**
 * DevExtreme (esm/__internal/grids/grid_core/m_accessibility.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import * as accessibility from "../../../ui/shared/accessibility";
export const registerKeyboardAction = function (viewName, instance, $element, selector, action) {
  let executeKeyDown = args => {};
  const keyboardController = instance.getController("keyboardNavigation");
  if (instance.option("useLegacyKeyboardNavigation") || keyboardController && !keyboardController.isKeyboardEnabled()) {
    return;
  }
  if ("filterPanel" === viewName) {
    executeKeyDown = args => {
      instance.executeAction("onKeyDown", args);
    };
    instance.createAction("onKeyDown");
  }
  accessibility.registerKeyboardAction(viewName, instance, $element, selector, action, executeKeyDown);
};